export default __webpack_public_path__ + "static/media/Prologue_Kyo2.fc51bc2e.svg";